import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { Button } from '@/ui/base/button';

interface FormBackButtonProps {
  /** Destino do voltar. Sem destino, volta uma posicao no historico. */
  to?: string;
  label?: string;
}

/**
 * Botao de voltar de formulario e de tela de detalhe. Icone do Lucide, alvo de
 * toque adequado (o tamanho do Button ja garante 44 px).
 */
export function FormBackButton({ to, label = 'Voltar' }: FormBackButtonProps) {
  const navegar = useNavigate();

  const aoClicar = () => {
    if (to) {
      navegar(to);
    } else {
      navegar(-1);
    }
  };

  return (
    <Button type="button" variant="ghost" size="sm" onClick={aoClicar} className="gap-1">
      <ArrowLeft className="h-4 w-4" aria-hidden="true" />
      {label && <span>{label}</span>}
    </Button>
  );
}
